import SubsectionTablet from "./SubsectionTablet";

export default SubsectionTablet;
export { SubsectionTablet };
